import React from 'react';

import BouncedEmailsContainer from '@totem/components/administration/bouncedEmails/BouncedEmailsContainer';
import {
  BouncedEmailsExtra,
  BouncedEmailsLayout,
} from '@totem/components/administration/bouncedEmails/BouncedEmailsLayout';
import { bouncedEmailsContainerConfiguration } from '@totem/components/administration/bouncedEmails/containerConfiguration';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const BouncedEmailsPage = () => (
  <ContentLayout>
    <InputContainer
      filterConfig={bouncedEmailsContainerConfiguration}
      defaultSort={{ field: 'updatedAt', direction: 'descend' }}
      defaultPageSize={20}
      componentKey={'dashboard.admin.bouncedEmails'}
      componentLabel={'Admin: Bounced Emails'}
    >
      <BouncedEmailsContainer>
        <IBCard isCovered title="Bounced Emails" extra={<BouncedEmailsExtra />}>
          <BouncedEmailsLayout />
        </IBCard>
      </BouncedEmailsContainer>
    </InputContainer>
  </ContentLayout>
);

export default BouncedEmailsPage;
